import { alignFlip, setUnchangedPositions } from '@moleculeone/draw';
import { MappedVectors, Mol, Reaction } from '@moleculeone/types';

import { ReversedProductMap } from './reverseMapping';

export function alignSubstratesToProduct(
  productMol: Mol,
  substrateMols: Mol[],
  substratesMap: Reaction['substratesMap'] = [],
  mapToProduct: ReversedProductMap
): Mol[] {
  if (!productMol) {
    return [];
  }

  // Aligns mols
  return substrateMols.map((substrateMol, idx) => {
    const alignMap: MappedVectors = {};

    for (const [substrateAtomId, mapId] of Object.entries(substratesMap[idx])) {
      const productAtomId = mapToProduct[String(mapId)];
      if (productMol.positions) {
        alignMap[substrateAtomId] = productMol.positions[String(productAtomId)];
      }
    }

    return setUnchangedPositions(substrateMol, alignFlip(substrateMol.positions, alignMap));
  });
}
